import config from '../../../config'
import http from './http-util'

class UnusedApplicationsApi {
  static getPendingApplications = (requestData, token) => {
    return http.post(
      token,
      `${config.unusedApplicationsUrl}/applications/unused/all`,
      JSON.stringify(requestData),
    )
  }

  static preparePendingApplication = (requestData, token) => {
    return http.post(
      token,
      `${config.unusedApplicationsUrl}/applications/unused/prepare_for_signing`,
      JSON.stringify(requestData),
    )
  }
}

export default UnusedApplicationsApi
